if (!customElements.get("product-share-link")) {
  class ProductShareLink extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector("button");
      this.label = this.querySelector("[data-share-label]");
      this.button.addEventListener("click", this.share.bind(this));
    }

    async share() {
      const { url, title } = this.dataset;

      // Native share sheet (mobile, Safari, recent Chrome); otherwise copy the link
      if (navigator.share) {
        try {
          await navigator.share({ url, title });
        } catch (error) {
          // The user closed the share sheet
        }
        return;
      }

      try {
        await navigator.clipboard.writeText(url);
        this.showCopied();
      } catch (error) {
        // Clipboard blocked (e.g. insecure context): nothing else to fall back to
      }
    }

    showCopied() {
      if (!this.originalLabel) this.originalLabel = this.label.textContent;
      this.label.textContent = this.dataset.copiedLabel;
      clearTimeout(this.resetTimer);
      this.resetTimer = setTimeout(() => {
        this.label.textContent = this.originalLabel;
      }, 2000);
    }
  }

  customElements.define("product-share-link", ProductShareLink);
}

if (!customElements.get("product-whatsapp-link")) {
  class ProductWhatsappLink extends HTMLElement {
    connectedCallback() {
      this.querySelector("a").addEventListener("click", this.onClick.bind(this));
    }

    onClick(event) {
      if (!this.hasAttribute("data-open-elfsight")) return;

      // Elfsight WhatsApp Chat floating bubble, selector from Elfsight's "custom button" guide.
      // When the widget is not loaded (lazy loading, monthly views limit) the direct link is used.
      const elfsightBubble = this.queryDeep(document, "[class*='Bubble__BubbleComponent-sc']");
      if (!elfsightBubble) return;

      event.preventDefault();
      elfsightBubble.click();
    }

    // Recent Elfsight embeds render the widget inside open shadow roots
    queryDeep(root, selector) {
      const match = root.querySelector(selector);
      if (match) return match;

      for (const element of root.querySelectorAll("*")) {
        if (!element.shadowRoot) continue;
        const shadowMatch = this.queryDeep(element.shadowRoot, selector);
        if (shadowMatch) return shadowMatch;
      }

      return null;
    }
  }

  customElements.define("product-whatsapp-link", ProductWhatsappLink);
}
